module.exports = __webpack_public_path__ + "static/media/folder.eda88bc8.svg";